import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CastingResponse } from 'src/app/interfaces/casting-response';
import { MovieDetailsResponse, ProductionCompany } from 'src/app/interfaces/movie-response';
import { PeliculasService } from 'src/app/services/peliculas.service';
import { Location } from '@angular/common';
import { Cast } from '../../interfaces/casting-response';
import { SimilarMovie, SimilarMovieResponse } from '../../interfaces/similar-movie-response';
import { Movie } from 'src/app/interfaces/cartelera-response';
import { combineLatest, Observable } from 'rxjs';

@Component({
  selector: 'app-pelicula',
  templateUrl: './pelicula.component.html',
  styleUrls: ['./pelicula.component.css']
})
export class PeliculaComponent implements OnInit {

  public movie!: MovieDetailsResponse;
  public casting!: CastingResponse[];
  public cast: Cast[] = [];
  public similars: SimilarMovie[] = [];
  public productionCompanies: ProductionCompany[] = [];
  public releaseDate!: Date;
  public id = 0;

  constructor(  private activatedRoute: ActivatedRoute,
                private peliculasService: PeliculasService,
                private location: Location,
                private router: Router) { }

  ngOnInit(): void {

    const id = this.activatedRoute.snapshot.params.id;

    combineLatest([
      this.peliculasService.getMovieDetail( id ),
      this.peliculasService.getCasting(id),
      this.peliculasService.getSimilarMovies(id)
    ]).subscribe( ([pelicula, cast, similarMovies]) => {
      // console.log(pelicula);
      if ( !pelicula ){
            this.router.navigateByUrl('/home');
            return;
          }

      this.movie = pelicula;
      this.productionCompanies = pelicula.production_companies;
      this.releaseDate = pelicula.release_date;

      this.cast = cast;

      this.similars = similarMovies;
    });

    // this.peliculasService.getMovieDetail( id ).subscribe( (resp: MovieDetailsResponse) => {
    //   // console.log(resp);
    //   if ( !resp ){
    //     this.router.navigateByUrl('/home');
    //     return;
    //   }
    //   this.productionCompanies = resp.production_companies;
    //   this.movie = resp;
    //   this.releaseDate = resp.release_date;
    // });

    // this.peliculasService.getCasting(id).subscribe( (cast: Cast[])  => {
    //   // console.log(cast);
    //   this.cast = cast;
    // });

    // this.peliculasService.getSimilarMovies(id).subscribe( (data: SimilarMovie[])  => {
    //   this.similars = data;
    //   // console.log(data);
    //   // console.log('simis');
    //   // console.log(this.similars);
    // });

  }
      onRegresar(): void{
      this.location.back();
      }

      goToMovie( id: number ): void{
        // console.log('id' + id);
        this.router.navigate(['/pelicula', id ]);
      }

}
